import cloneDeep from "lodash/cloneDeep";
import * as api from "../../api/bookmarksApi";
import type { BookmarkType } from "../../types/bookmarkType";
const BookmarkListModel = {
  state: {
    isBookmarkListLoading: false,
    total: 0,
    bookmarkList: [] as Array<any>,
  },
  reducers: {
    addBookmark(state: Record<string, any>, payload: BookmarkType): any {
      let bookmarkList = cloneDeep(state.bookmarkList);
      let bookmark = { ...payload };
      bookmarkList.push(bookmark);
      return { ...state, bookmarkList: bookmarkList };
    },

    removeBookmark(state: Record<string, any>, payload: number): any {
      let bookmarkList = cloneDeep(state.bookmarkList);
      let validBookmarkList = bookmarkList.filter(
        bookmark => bookmark.id !== payload
      );
      return { ...state, bookmarkList: validBookmarkList };
    },

    updateBookmarkList: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, bookmarkList: payload.bookmarkList };
    },
    setBookmarksTotal: (state: Record<string, any>, payload: number): any => {
      return { ...state, total: payload };
    },

    setBookmarkListRequest(state: Record<string, any>): any {
      return { ...state, isBookmarkListLoading: true };
    },

    setBookmarkListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        bookmarkList: payload.bookmarkList,
        isBookmarkListLoading: false,
      };
    },

    purgeBookmarkList: (state: Record<string, any>): any => {
      return { ...state, bookmarkList: [] };
    },
  },
  effects: {
    async setBookmarkList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setBookmarkListRequest();
      return api
        .getBookmarkList()
        .then((bookmarkData: any) => {
          if (
            bookmarkData !== undefined &&
            bookmarkData.bookmarks !== undefined
          ) {
            this.setBookmarkListSuccess({
              bookmarkList: bookmarkData.bookmarks,
              total: bookmarkData.total,
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },
  },
};
export default BookmarkListModel;
